import * as React from "react"


const WIDGET_SRC = "https://dipi-brands-agent-1035715358092.europe-west1.run.app/widget.js"
const SCRIPT_ID = "dipi-brands-agent-widget"

// Injects the DIPI Brands chatbot widget script once the user is logged in.
// The external widget.js reads its config from the data-* attributes and renders
// its own chat bubble, so this component renders no UI of its own.
export default function DipiBrandsChatWidget({ app = "dipi", customer, username }) {
	React.useEffect(() => {
		if (!customer || !username) return
		if (document.getElementById(SCRIPT_ID)) return

		const script = document.createElement("script")
		script.id = SCRIPT_ID
		script.src = WIDGET_SRC
		script.async = true
		script.dataset.app = app
		script.dataset.customer = String(customer)
		script.dataset.username = String(username)
		document.body.appendChild(script)

		return () => document.getElementById(SCRIPT_ID)?.remove()
	}, [app, customer, username])

	return null
}
